var $ = require('jquery');
var moduleSelector = require('diy/site-admin/module-selector/moduleSelector');
var siteAdminApi = require('diy/site-admin/main/api');

/**
 * @see DeepLinking.php for info about deeplinking
 */

;(function() {

    var data = null;

    var init = function(dt) {
        data = dt;

        if (data) {
            var cat = data.deepLinkCategory,
                item = data.deepLinkItem,
                params = data.deepLinkParams;

            /* if the main section is admin (SiteAdmin) */
            if (cat === 'admin') {
                if (item === 'elements') {
                    /* when Module Selector is opened, it triggers this event, which we catch only once */
                    $(document).one('moduleSelectorInitialized', function(e) {
                        if (params && params.scrollTo) {
                            moduleSelector.default.focusItem('module', params.scrollTo, params.category);
                        } else if (params && params.category) {
                            moduleSelector.default.openCategory(params.category);
                        }
                    });
                    siteAdminApi.triggerMenuItem('cc-sa-item-elements');
                } else if(item === 'fbpb-settings') {
                    /* the deepLinkParams coming with this query make sense for the FBPB, not for DIY */
                    siteAdminApi.triggerMenuItem('cc-sa-item-fbpb-settings');
                } else if(item === 'fbpb') {
                    siteAdminApi.triggerMenuItem('cc-sa-item-fbpb');
                }
            }

            /* if the main section is module (any module on the page) */
            if (cat === 'module') {
                var it = parseInt(item);
                if (!isNaN(it) && it in mm) {
                    if (params && params.action === 'open') {
                        /* we delay this task with 300 ms, as this also performs scrolling
                         * to this module and it's best that things have arranged fine in the page */
                        /* also works WITHOUT the timeout, but it's like this for a visual effect */
                        setTimeout(function() {
                            mm[it].open();
                        }, 300);
                    }
                }
            }
        }
    };

    var getData = function() {
        return data;
    };

    var path = [];
    var currentStep = 0;
    var handlers = {};
    var demoMode = false;

    var requestPath = function (newPath, useDemoMode, scrollToTop) {
        path = newPath;
        currentStep = 0;
        demoMode = useDemoMode ? true : false;
        processPath(demoMode);
        if (scrollToTop) $.scrollTo(0);
    };

    var cancelPath = function () {
        path = [];
        currentStep = 0;
        demoMode = false;
    };

    var processPath = function () {
        var label;
        for (var i = currentStep; i < path.length; i ++) {
            label = path[i].label;
            if (typeof handlers[label] === 'function') {
                try {
                    handlers[label](path[i].params, demoMode);
                    currentStep++;
                } catch (e) {
                    cancelPath();
                    break;
                }
            } else {
                // we don't have any handler yet
                // for the currentStep, so we stop
                break;
            }
        }
    };

    var registerHandler = function (handler, label) {
        handlers[label] = handler;
        processPath();
    };

    var unregisterHandler = function (label) {
        delete handlers[label];
    };

    return $.extend(this, {
        init: init,
        getData: getData,
        requestPath: requestPath,
        registerHandler: registerHandler,
        unregisterHandler: unregisterHandler
    });

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/util/deeplinking.js
 ** module id = 9
 ** module chunks = 0
 **/